import { render, staticRenderFns } from "./tm-review.vue?vue&type=template&id=b457b77c&scoped=true&"
import script from "./tm-review.vue?vue&type=script&lang=ts&"
export * from "./tm-review.vue?vue&type=script&lang=ts&"
import style0 from "./tm-review.vue?vue&type=style&index=0&id=b457b77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b457b77c",
  null
  
)

export default component.exports